import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface CheckboxGroupData {
  value: string;
  displayTitle?: string;
  displayText?: string;
  displayHtml?: string;
}

@Component({
  selector: 'ds-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true
    }
  ]
})
export class CheckboxGroupComponent implements ControlValueAccessor {

  private _disabled = false;

  @Input() data: CheckboxGroupData[];
  @Input() ariaDescribedBy: string;
  @Input() name = 'item';

  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  selected: Array<any> = [];
  propagateChange = (_: any) => {
    // This is intentional
  };

  constructor(private cdr: ChangeDetectorRef) {
  }

  set value(value: Array<string>) {
    this.selected = (this.selected.includes(value[0])) ?
      this.selected.filter(el => el !== value[0]) : [...this.selected, ...value];
    this.propagateChange(value);
    this.cdr.detectChanges();
  }

  get value(): Array<string> {
    return this.selected;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    // This is intentional
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    if (value !== undefined) {
      this.selected = [];
    }
  }
}
